import AniversarioLista from './AniversarioLista';
import FaltandoDocumentacaoLista from './FaltandoDocumentacaoLista';
import Lista from './Lista';

export const UsuarioAniversarioLista = AniversarioLista;
export const UsuarioFaltandoDocumentacaoLista = FaltandoDocumentacaoLista;
export const UsuarioLista = Lista;
